import { compose } from 'redux'
import { connect } from 'react-redux'
import ConversationList from 'components/ConversationList'
import { emptyArr } from 'util/arrays'
import {
  selectCurrentQueryId,
  selectCurrentSearchQueryIsLoaded,
  selectCurrentSearchQueryIsLoadingMore,
  selectCurrentSearchHasMore,
  selectCurrentSearchConversationIds,
  selectCurrentSearchQueryFilter,
} from 'ducks/searches/selectors'
import { doFetchFolderCounts } from 'ducks/searches/operations/doFetchFolderCounts'
import { doFetchRooms, doOpenRoomPageById } from 'ducks/chat/actions/rooms'
import { selectRoomIdFromUrl } from 'ducks/chat/selectors/rooms'
import withMatrixClient from '../withMatrixClient'

import ChatListItem from './ListItem'
import withLoadRooms from './withLoadRooms'

const select = state => {
  return {
    currentQueryId: selectCurrentQueryId(state),
    hasLoaded: selectCurrentSearchQueryIsLoaded(state),
    canLoadMore: selectCurrentSearchHasMore(state),
    isLoadingMore: selectCurrentSearchQueryIsLoadingMore(state),
    conversationListQueryKey: selectCurrentQueryId(state),
    isSelectionMode: false,
    isConversationsCurtainVisible: false,
    scrollY: 0,
    selectedConversationIds: emptyArr,
    conversationIds: selectCurrentSearchConversationIds(state),
    currentConversationId: selectRoomIdFromUrl(state),
    ListItem: ChatListItem,
    queryFilter: selectCurrentSearchQueryFilter(state),
  }
}

const perform = {
  /* eslint-disable no-console */
  markBulkSelectionMode: () => {
    console.log('NOTIMPLEMENTED: markBulkSelectionMode')
  },
  openConversationPage: () => {
    console.log('NOTIMPLEMENTED: openConversationPage')
  },
  toggleConversationSelection: () => {
    console.log('NOTIMPLEMENTED: toggleConversationSelection')
  },
  onRangedSelection: () => {
    console.log('NOTIMPLEMENTED: onRangedSelection')
  },
  loadMore: doFetchRooms,
  onTopChanged: () => {
    console.log('NOTIMPLEMENTED: onTopChanged')
  },
  closeConversation: () => {
    console.log('NOTIMPLEMENTED: closeConversation')
  },
  openConversation: () => {
    console.log('NOTIMPLEMENTED: openConversation')
  },
  navigateToConversation: doOpenRoomPageById,
  fetchFolderCounts: doFetchFolderCounts,
}

const RoomList = compose(withMatrixClient)(
  connect(select, perform)(compose(withLoadRooms)(ConversationList))
)

export default RoomList
